import $ from 'jquery';
import BaseFeature from '../../foundation/base/base';

const classes = {
    active: 'o-hero-slider--active'
};

const windowSize = {
    sm: 640
};

export default class HeroSlider extends BaseFeature {
	constructor(element) {
		super(element);
        this.initDomCache();
        this.el = element;
        this.$el = $(this.el);
        
        this.slider; // Set to an ID used by the timout function
        this.sliderActive = false; // Sets to true when slider becomes active
        this.slideStart = 0; // Should start at first slide
        this.slides = this.$el.find('[data-js="slide"]'); // Get all the slides
        this.timeout = this.getTimeout(); // Get the custom timeout
        this.resizeTimeout = null; // Used by the resize function to throttle resize event

        this.addBackgroundsToPage();
        this.setBackground(0);

        this.initEvents();

        if(window.innerWidth > 640)this.startSlider();
    }

    initEvents() {
        window.addEventListener('resize', (e) => {
            this.resizeThrottler();
		});
    }

    startSlider() {
        this.sliderActive = true;
        this.el.classList.add(classes.active);
        this.setBackground(0);
        this.setSliderHeight();
        let current = 0;
        this.slider = setInterval(() => {
            for (var i = 0; i < this.slides.length; i++) {
                this.slides[i].setAttribute('style', 'opacity:0;visibility:hidden;');
                // this.slides[i].style.opacity = 0;
            }
            current = (current != this.slides.length - 1) ? current + 1 : 0;
            this.slides[current].setAttribute('style', 'opacity:1;visibility:visible;');
            // this.slides[current].style.opacity = 1;
            this.nextBackground(current);
        }, this.timeout);
    }

    stopSlider() {
        clearInterval(this.slider);
        this.sliderActive = false;
        this.setBackground(0);
        this.el.removeAttribute('style');
        this.el.classList.remove(classes.active);
        for (var i = 0; i < this.slides.length; i++) {
            this.slides[i].removeAttribute('style');
        }
    }

    setSliderHeight() {
        this.el.setAttribute('style', 'margin-bottom:' + this.calculateHeight() + 'px;');
    }

    calculateHeight() {
        var height = 0;
        for(var i=0;i < this.slides.length; i++) {
            if(this.slides[i].offsetHeight > height) height = this.slides[i].offsetHeight;
        }
        return height;
    }

    getTimeout() {
        if(this.element.getAttribute('data-timeout')){
            return parseInt(this.element.getAttribute('data-timeout') * 1000);
        }
        return 5000;
    }

    resizeThrottler() {
        // Ignore resize events as long as an actualResizeHandler execution is in the queue
        if ( !this.resizeTimeout ) {
            this.resizeTimeout = setTimeout(() => {
                this.resizeTimeout = null;
                this.actualResizeHandler();
                // The actualResizeHandler will execute at a rate of 15fps
            }, 66);
        }
    }

    actualResizeHandler() {
        if (window.innerWidth < windowSize.sm) {
            if(this.sliderActive) {
                this.stopSlider();
            }
            else {  
                this.el.removeAttribute('style');
            }
        }
        else {
            if(!this.sliderActive){
                this.startSlider();
            }
            else {
                this.setSliderHeight();
            }
        }
    }

    addBackgroundsToPage() {
        let backgrounds = [];
        for (let i = 0; i < this.slides.length; i++) {
         backgrounds.push(this.slides[i].getAttribute('data-background'));   
        }
        this.publish('/page/addBackgrounds', {
            backgrounds
        });
    }
    
    setBackground(current) {
        this.publish('/page/setBackground', {
            current
        });
    }

    nextBackground(current) {
        this.publish('/page/nextBackground', {
            current
        });
    }
}
